import { useState, useContext } from "react"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import { Box, Paper, TextField, Tooltip, IconButton, Grid, Typography } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, api, showWarning } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import getIconComponent from "../../utils/getIconComponent"
import Save from "@mui/icons-material/Save"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const StyledRoot = {
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "20px",
  backgroundColor: "#f5f7fa",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
}

const CrearTipoMotivo = () => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)

  // Estado inicial del formulario[cite: 19]
  const [formData, setFormData] = useState({
    tmotcodigo: "",
    tmotdescripcion: "",
    tmotstatus: "A",
  })

  // Mutación para guardar la creación[cite: 19]
  const {
    mutateAsync: SaveCreacionTipoMotivo,
    isPending: isSavingCreacion,
    isError,
  } = useMutation({
    queryKey: ["isCreatingTipoMotivo"],
    fn: async (data) => {
      const response = await api.post("/TipoMotivo/createTipoMotivo", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1), // Retorna a la grilla tras guardar[cite: 19]
  })

  // Manejador de cambios para limpiar, convertir a mayúsculas y limitar entradas[cite: 19]
  const handleInputChange = (field, value) => {
    let finalValue = value.toUpperCase()

    if (field === "tmotcodigo") finalValue = finalValue.slice(0, 3)
    else if (field === "tmotdescripcion") finalValue = finalValue.slice(0, 60)

    setFormData((prev) => ({ ...prev, [field]: finalValue }))
  }

  // Ejecución y validación al intentar guardar[cite: 19]
  const handleSubmit = async (e) => {
    if (e) e.preventDefault()

    // Validaciones del frontend[cite: 19]
    if (!formData.tmotcodigo.trim()) return showWarning("El Código del Tipo de Motivo es obligatorio")
    if (!formData.tmotdescripcion.trim()) return showWarning("La Descripción es obligatoria")

    await SaveCreacionTipoMotivo(formData)
  }

  // Configuración de la barra de acciones superior (Solo GRABAR)[cite: 19]
  const guardarAction = selectedMenuInfo?.data?.barraAcciones?.find((action) => action?.acccaption === "GRABAR")

  const toolbarActions = guardarAction
    ? [
        {
          label: guardarAction.acccaption,
          key: guardarAction.acccaption,
          icon: getIconComponent(guardarAction.accnameicono, guardarAction.acctipoico),
        },
      ]
    : [{ label: "Guardar", key: "GUARDAR", icon: <Save /> }]

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        {/* TOP Bar - Botonera[cite: 19] */}
        <Box sx={{ mb: 2 }}>
          {toolbarActions.map((action) => (
            <Tooltip title={action.label} key={action.key}>
              <IconButton
                onClick={handleSubmit}
                disabled={isSavingCreacion}
                sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1 }}
              >
                {action.icon}
              </IconButton>
            </Tooltip>
          ))}
        </Box>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Crear Nuevo Tipo de Motivo</b>
        </div>

        <CustomBackdrop isLoading={isSavingCreacion} />

        <Box sx={StyledRoot}>
          <Paper
            elevation={3}
            sx={{ p: 4, borderRadius: 3, background: "white" }}
            component="form"
            onSubmit={handleSubmit}
          >
            <Typography variant="h6" color="primary" gutterBottom>
              Datos del Tipo de Motivo
            </Typography>

            <Grid container spacing={3}>
              {/* CÓDIGO */}
              <Grid item xs={12} sm={3}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label="Código *"
                  value={formData.tmotcodigo}
                  onChange={(e) => handleInputChange("tmotcodigo", e.target.value)}
                  error={isError && !formData.tmotcodigo}
                  inputProps={{ maxLength: 3 }}
                />
              </Grid>

              {/* DESCRIPCIÓN */}
              <Grid item xs={12} sm={9}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  label="Descripción *"
                  value={formData.tmotdescripcion}
                  onChange={(e) => handleInputChange("tmotdescripcion", e.target.value)}
                  error={isError && !formData.tmotdescripcion}
                  inputProps={{ maxLength: 60 }}
                />
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default CrearTipoMotivo
